import { render, staticRenderFns } from "./OnboardingCompanyTOCForm.vue?vue&type=template&id=6ac3eacc"
import script from "./OnboardingCompanyTOCForm.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyTOCForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports